export const seriesId = [
  "c0_pibpm",
  "c0_poblacion",
  "c0_pib_hora_trabajada",
  "c0_horas_trabjadas_persona",
  "c1_horas_trabajadas_persona",
  "c1_horas_trabajador_etc",
  "c1_trabajador_etc_pet",
  "c1_pet_poblacion",
  "c2_cantidad_de_trabajo",
  "c2_calidad_del_trabajo_renta",
  "c2_input_de_trabajo_renta",
  "c2_calidad_del_trabajo_educacion",
  "c2_input_de_trabajo_educacion",
  "c3_capital",
  "c3_trabajo",
  "c3_tierra",
  "c4_pib_hora_trabajada",
  "c4_input_de_capital_hora",
  "c4_input_de_tierra_hora",
  "c4_calidad_del_trabajo_renta",
  "c4_productividad_total_de_los_factores_renta",
  "c4_calidad_del_trabajo_educacion",
  "c4_productividad_total_de_los_factores_educacion"
]

export const seriesEsp = [
  "PIBmp",
  "Población",
  "PIB/hora trabajada",
  "Horas trabajadas/Persona",
  "Horas trabajadas/Persona (2010=100)",
  "Horas/trabajador ETC*",
  "Trabajador ETC/PET**",
  "PET/Población",
  "Cantidad de trabajo: enfoque de renta",
  "Calidad del trabajo: enfoque de renta",
  "Input de trabajo: enfoque de renta",
  "Calidad del trabajo: enfoque de educación",
  "Input de trabajo: enfoque de educación",
  "Capital",
  "Trabajo",
  "Tierra",
  "PIB/hora trabajada",
  "Input de Capital/hora",
  "Input de Tierra/hora",
  "Calidad del trabajo: enfoque de renta",
  "Productividad Total de los Factores: enfoque de renta",
  "Calidad del trabajo: enfoque de educación",
  "Productividad Total de los Factores: enfoque de educación"
]

export const seriesEng = [
  "GDPmp",
  "Population",
  "GDP/hour worked",
  "Hours worked/Person",
  "Hours per head",
  "Hours/FTE worker",
  "FTE worker/WAN",
  "WAN/Population",
  "Labour Quantity: Income-based",
  "Labour Quality: Income-based",
  "Labour Input: Income-based",
  "Labour Quality: Education-based",
  "Labour Input: Education-based",
  "Capital Share",
  "Labour Share",
  "Land Share",
  "GDP/hour",
  "Capital Input/hour",
  "Land Input/hour",
  "Labour Quality: Income-based",
  "TFP: Income-based",
  "Labour Quality: Education-base",
  "TFP: Education-base"
]

export const groupsEsp = [
  "PIB en términos reales y su composición",
  "PIB en términos reales y su composición",
  "PIB en términos reales y su composición",
  "PIB en términos reales y su composición",
  "Horas trabajadas por persona y su composición",
  "Horas trabajadas por persona y su composición",
  "Horas trabajadas por persona y su composición",
  "Horas trabajadas por persona y su composición",
  "Input de de trabajo y su composición",
  "Input de de trabajo y su composición",
  "Input de de trabajo y su composición",
  "Input de de trabajo y su composición",
  "Input de de trabajo y su composición",
  "Participación de los factores (% PIB)",
  "Participación de los factores (% PIB)",
  "Participación de los factores (% PIB)",
  "El crecimiento del PIB por hora trabajada y sus determinantes",
  "El crecimiento del PIB por hora trabajada y sus determinantes",
  "El crecimiento del PIB por hora trabajada y sus determinantes",
  "El crecimiento del PIB por hora trabajada y sus determinantes",
  "El crecimiento del PIB por hora trabajada y sus determinantes",
  "El crecimiento del PIB por hora trabajada y sus determinantes",
  "El crecimiento del PIB por hora trabajada y sus determinantes"
]

export const groupsEng = [
  "Real GDP and its Composition",
  "Real GDP and its Composition",
  "Real GDP and its Composition",
  "Real GDP and its Composition",
  "Hours Worked per Person and its Composition",
  "Hours Worked per Person and its Composition",
  "Hours Worked per Person and its Composition",
  "Hours Worked per Person and its Composition",
  "Labour Input and its Composition",
  "Labour Input and its Composition",
  "Labour Input and its Composition",
  "Labour Input and its Composition",
  "Labour Input and its Composition",
  "Factors Shares (% GDP)",
  "Factors Shares (% GDP)",
  "Factors Shares (% GDP)",
  "GDP per Hour Worked and its Determinants (2010=100)",
  "GDP per Hour Worked and its Determinants (2010=100)",
  "GDP per Hour Worked and its Determinants (2010=100)",
  "GDP per Hour Worked and its Determinants (2010=100)",
  "GDP per Hour Worked and its Determinants (2010=100)",
  "GDP per Hour Worked and its Determinants (2010=100)",
  "GDP per Hour Worked and its Determinants (2010=100)"
]
